import React from 'react';
import classNames from 'classnames';

export const VerticalGradientOverlay = ({
  className,
  as: Component = 'div',
  fromDirection = 'b', 
  fromColor = 'white', 
  height = 8,
}) => (
  <Component className={classNames(`bg-gradient-to-${fromDirection} from-${fromColor} h-${height} absolute z-20`, className)} />
)

export default VerticalGradientOverlay;
